var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BModal,{ref:"modal",attrs:{"scrollable":"","title":`Trade Details${_vm.trade ? ` for ${_vm.trade.referenceNumber}` : ''}`,"modal-class":"side-modal","hide-footer":""}},[(_vm.trade)?_c(_setup.TradeDetails,{attrs:{"trade":_vm.trade}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }